class checkStreamsCtrl {
    constructor($rootScope, $scope, httpRequest) {
        // 初始化表单数据
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
        }

        $scope.dictData = {}
        $scope.dictData.approve_type = [
            { enumTypeCode: null, enumName: '或签', enumCode: '1' },
            { enumTypeCode: null, enumName: '会签', enumCode: '2' },
        ]
        $scope.dictData.inform_type = [
            { enumTypeCode: null, enumName: '邮件通知', enumCode: 'email' },
            { enumTypeCode: null, enumName: '系统消息', enumCode: 'message' },
        ]
        $scope.dictData.compare_type = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '或', enumCode: '8' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
            { enumTypeCode: null, enumName: 'equal', enumCode: '7' },
        ]
        $scope.dictData.compare_type_money = [
            { enumTypeCode: null, enumName: '介于两个值之间', enumCode: '9' },
            { enumTypeCode: null, enumName: '>', enumCode: '1' },
            { enumTypeCode: null, enumName: '<', enumCode: '2' },
            { enumTypeCode: null, enumName: '=', enumCode: '3' },
            { enumTypeCode: null, enumName: '>=', enumCode: '4' },
            { enumTypeCode: null, enumName: '<=', enumCode: '5' },
            { enumTypeCode: null, enumName: '!=', enumCode: '6' },
        ]
        const typecodeArr = '["inv_type","invoice_nature","zsxm_dm"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
    }
}

checkStreamsCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default checkStreamsCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/checkStreams/checkStreamsCtrl.js